import { QuestionnaireResponseItem } from '@medplum/fhirtypes'
import {
  AdapterOptions,
  FlatAnswerMutation,
  SectionAdapter
} from 'components/Assessments/adapters/types'
import { getAnswerValuesFromItems } from 'components/Assessments/helpers'
import { RocFormData } from '../../types/RocFormData'
import { RocAssessmentQuestionnaireItem } from '../../types/questionnaire'
import { RocFormField } from '../../types/RocFormField'

export class DischargePlanningAdapter extends SectionAdapter<RocFormData> {
  extractFormData(
    flatAnswers: Record<string, QuestionnaireResponseItem>,
    _options?: AdapterOptions
  ): Partial<RocFormData> {
    const dischargePlans = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS]],
      RocAssessmentQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS
    )?.at(0)
    const rehabilitationPotential = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]],
      RocAssessmentQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL
    )?.at(0)
    const notes = getAnswerValuesFromItems(
      [flatAnswers[RocAssessmentQuestionnaireItem.DISCHARGE_PLANNING_NOTES]],
      RocAssessmentQuestionnaireItem.DISCHARGE_PLANNING_NOTES
    )?.at(0)
    return {
      [RocFormField.DISCHARGE_PLANNING_DISCHARGE_PLANS]: dischargePlans,
      [RocFormField.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]: rehabilitationPotential,
      [RocFormField.DISCHARGE_PLANNING_NOTES]: notes
    }
  }

  buildFlatAnswers(formData: RocFormData): FlatAnswerMutation[] {
    return [
      {
        linkId: RocAssessmentQuestionnaireItem.DISCHARGE_PLANNING_DISCHARGE_PLANS,
        value: formData[RocFormField.DISCHARGE_PLANNING_DISCHARGE_PLANS]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL,
        value: formData[RocFormField.DISCHARGE_PLANNING_REHABILITATION_POTENTIAL]
      },
      {
        linkId: RocAssessmentQuestionnaireItem.DISCHARGE_PLANNING_NOTES,
        value: formData[RocFormField.DISCHARGE_PLANNING_NOTES]
      }
    ]
  }
}
